import { render, staticRenderFns } from "./Step4CycloneInsurance.vue?vue&type=template&id=20687ec2&"
import script from "./Step4CycloneInsurance.vue?vue&type=script&lang=js&"
export * from "./Step4CycloneInsurance.vue?vue&type=script&lang=js&"
import style0 from "./Step4CycloneInsurance.vue?vue&type=style&index=0&id=20687ec2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports